import { render, staticRenderFns } from "./SimpleResourceView.vue?vue&type=template&id=c2cd52ae&"
import script from "./SimpleResourceView.vue?vue&type=script&lang=js&"
export * from "./SimpleResourceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports